import { render, staticRenderFns } from "./SelectedItemOptions.vue?vue&type=template&id=cc45aa6e&lang=pug&"
import script from "./SelectedItemOptions.vue?vue&type=script&lang=js&"
export * from "./SelectedItemOptions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports